import { useEffect } from 'react';

let hasObserver = false;

/**
 * Used to clean up default fonts from elements inside the section-container
 * to avoid the GCF being affected by the font.
 * GCF_TEST_ID: The testid from GCF's section.
 * CC_UI_DEFAULT_FONT: The default font set by CC-UI.
 */
export const useCleanUpDefaultFonts = () => {
  const GCF_TEST_ID = 'section-container';
  const CC_UI_DEFAULT_FONT = 'Roboto, sans-serif';

  useEffect(() => {
    const cleanUpFonts = (container: Element) => {
      const children = container.querySelectorAll('*');
      for (const child of children) {
        const htmlChild = child as HTMLElement;
        if (htmlChild.style.fontFamily) continue;

        const computedStyle = window.getComputedStyle(child);
        if (computedStyle.fontFamily === CC_UI_DEFAULT_FONT) {
          htmlChild.style.fontFamily = 'inherit';
        }
      }
    };

    const existingNodes = document.querySelectorAll(
      `[data-testid="${GCF_TEST_ID}"]`,
    );
    existingNodes.forEach((node) => cleanUpFonts(node));
    if (hasObserver) return;
    hasObserver = true;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            if ((node as any).dataset.testid === GCF_TEST_ID) {
              cleanUpFonts(node);
            } else {
              const inner = node.querySelectorAll?.(
                `[data-testid="${GCF_TEST_ID}"]`,
              );
              inner?.forEach((el) => cleanUpFonts(el));
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
      hasObserver = false;
    };
  }, []);
};
